// Login
export const LoginData = {
  en: {
    welcomeBack: "Welcome back",
    loginText: "Login to your LMS account",
    identifierLabel: "Email, Username, or Phone",
    identifierPlaceholder: "Enter your email, username, or phone",
    passwordLabel: "Password",
    forgotPassword: "Forgot your password?",
    stayLoggedIn: "Stay logged in",
    signIn: "Sign In",
    orContinueWith: "Or continue with",
    loginWithGoogle: "Login with Google",
    noAccount: "Don't have an account?",
    signUp: "Sign up",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    and: "and",
    byClicking: "By clicking continue, you agree to our",
  },
  ar: {
    welcomeBack: "مرحبًا بعودتك",
    loginText: "قم بتسجيل الدخول إلى حسابك في LMS",
    identifierLabel: "البريد الإلكتروني أو اسم المستخدم أو الهاتف",
    identifierPlaceholder:
      "أدخل بريدك الإلكتروني أو اسم المستخدم أو رقم الهاتف",
    passwordLabel: "كلمة المرور",
    forgotPassword: "هل نسيت كلمة المرور؟",
    stayLoggedIn: "البقاء متصلاً",
    signIn: "تسجيل الدخول",
    orContinueWith: "أو تابع باستخدام",
    loginWithGoogle: "تسجيل الدخول باستخدام Google",
    noAccount: "ليس لديك حساب؟",
    signUp: "سجل",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    and: "و",
    byClicking: "من خلال النقر على `متابعة`، فإنك توافق على شروطنا",
  },
  fr: {
    welcomeBack: "Content de vous revoir",
    loginText: "Connectez-vous à votre compte LMS",
    identifierLabel: "Email, Nom d'utilisateur ou Téléphone",
    identifierPlaceholder: "Entrez votre email, nom d'utilisateur ou téléphone",
    passwordLabel: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    stayLoggedIn: "Rester connecté",
    signIn: "Se connecter",
    orContinueWith: "Ou continuez avec",
    loginWithGoogle: "Se connecter avec Google",
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
    and: "and",
    byClicking: "En cliquant sur Continuer, vous acceptez nos",
  },
};

// Register
export const RegisterData = {
  en: {
    createAccount: "Create an account",
    signUp: "Sign up for your LMS account",
    name: "Name*",
    email: "Email*",
    password: "Password*",
    confirmPassword: "Confirm Password*",
    username: "Username",
    phone: "Phone",
    signUpButton: "Sign Up",
    orContinueWith: "Or continue with",
    loginWithGoogle: "Login with Google",
    alreadyHaveAccount: "Already have an account?",
    logIn: "Log in",
    termsAndConditions: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    and: "and",
    byClicking: "By clicking continue, you agree to our",
    title: "Register Successfully",
    description: "Congratulations! Your account has been successfully created.",
    button: "Go to home",
  },
  ar: {
    createAccount: "إنشاء حساب",
    signUp: "اشترك في حساب LMS الخاص بك",
    name: "الاسم*",
    email: "البريد الإلكتروني*",
    password: "كلمة المرور*",
    confirmPassword: "تأكيد كلمة المرور*",
    username: "اسم المستخدم",
    phone: "الهاتف",
    signUpButton: "سجل",
    orContinueWith: "أو تابع باستخدام",
    loginWithGoogle: "تسجيل الدخول باستخدام Google",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    logIn: "تسجيل الدخول",
    termsAndConditions: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    and: "و",
    byClicking: "من خلال النقر على `متابعة`، فإنك توافق على شروطنا",
    title: "تم التسجيل بنجاح",
    description: "تهانينا! تم إنشاء حسابك بنجاح.",
    button: "الذهاب إلى الصفحة الرئيسية",
  },
  fr: {
    createAccount: "Créer un compte",
    signUp: "Inscrivez-vous pour votre compte LMS",
    name: "Nom*",
    email: "E-mail*",
    password: "Mot de passe*",
    confirmPassword: "Confirmer le mot de passe*",
    username: "Nom d'utilisateur",
    phone: "Téléphone",
    signUpButton: "S'inscrire",
    orContinueWith: "Ou continuez avec",
    loginWithGoogle: "Se connecter avec Google",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    logIn: "Se connecter",
    termsAndConditions: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
    and: "and",
    byClicking: "En cliquant sur Continuer, vous acceptez nos",
    title: "Inscription réussie",
    description: "Félicitations ! Votre compte a été créé avec succès.",
    button: "Aller à l'accueil",
  },
};

// ForgetPassword
export const ForgetPasswordData = {
  en: {
    title: "Forgot Password",
    subtitle: "Enter your email to reset your password",
    emailLabel: "Email",
    emailPlaceholder: "m@example.com",
    resetButton: "Reset Password",
    rememberPassword: "Remember your password?",
    backToLogin: "Back to Login",
  },
  fr: {
    title: "Mot de passe oublié",
    subtitle: "Entrez votre email pour réinitialiser votre mot de passe",
    emailLabel: "E-mail",
    emailPlaceholder: "m@exemple.com",
    resetButton: "Réinitialiser le mot de passe",
    rememberPassword: "Vous vous souvenez de votre mot de passe ?",
    backToLogin: "Retour à la connexion",
  },
  ar: {
    title: "نسيت كلمة المرور",
    subtitle: "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "m@example.com",
    resetButton: "إعادة تعيين كلمة المرور",
    rememberPassword: "هل تذكر كلمة المرور؟",
    backToLogin: "العودة إلى تسجيل الدخول",
  },
};

// ResetPassword
export const ResetPasswordData = {
  en: {
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm New Password",
    newPasswordPlaceholder: "Enter your new password",
    confirmPasswordPlaceholder: "Confirm your new password",
    resetPasswordButton: "Reset Password",
  },
  fr: {
    newPasswordLabel: "Nouveau mot de passe",
    confirmPasswordLabel: "Confirmer le nouveau mot de passe",
    newPasswordPlaceholder: "Entrez votre nouveau mot de passe",
    confirmPasswordPlaceholder: "Confirmez votre nouveau mot de passe",
    resetPasswordButton: "Réinitialiser le mot de passe",
  },
  ar: {
    newPasswordLabel: "كلمة المرور الجديدة",
    confirmPasswordLabel: "تأكيد كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    confirmPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",
    resetPasswordButton: "إعادة تعيين كلمة المرور",
  },
};

// CheckCode
export const CheckCodeData = {
  en: {
    title: "Reset Your Password",
    subtitleCodeSuccess: "Enter your new password",
    subtitleEnterCode: "Enter the code you received",
    resendCode: "Resend Code",
    submitCode: "Submit Code",
  },
  fr: {
    title: "Réinitialiser votre mot de passe",
    subtitleCodeSuccess: "Entrez votre nouveau mot de passe",
    subtitleEnterCode: "Entrez le code que vous avez reçu",
    resendCode: "Renvoyer le code",
    submitCode: "Soumettre le code",
  },
  ar: {
    title: "إعادة تعيين كلمة المرور",
    subtitleCodeSuccess: "أدخل كلمة المرور الجديدة الخاصة بك",
    subtitleEnterCode: "أدخل الرمز الذي تلقيته",
    resendCode: "إعادة إرسال الرمز",
    submitCode: "إرسال الرمز",
  },
};

// Header
export const HeaderData = {
  en: {
    academyName: "Ali Academy",
    register: "Register",
    login: "Login",
  },
  ar: {
    academyName: "علي أكاديمي",
    register: "تسجيل",
    login: "تسجيل الدخول",
  },
  fr: {
    academyName: "Académie Ali",
    register: "S'inscrire",
    login: "Se connecter",
  },
};

// Sidebar
export const SidebarData = {
  en: {
    quizzes: "Quizzes",
    homeWorks: "Home Works",
    logoName: "Ali Academy",
    dashboard: "Dashboard",
    overview: "Overview",
    teacherManagement: "Teacher Management",
    categories: "Categories",
    courses: "Courses",
    myCourses: "My Courses",
    coursesWatched: "Courses I watched",
    completedCourses: "Completed courses",
    currentCourses: "My current courses",
    myLectures: "My Lectures",
    schedule: "Schedule",
    community: "Community",
    invoices: "Invoices",
    past: "Past",
    current: "Current",
    upcoming: "Upcoming",
    settings: "Settings",
    logout: "Logout",
    noSubCategory: "There is no Sub Categories",
    noCategory: "There is no Categories",
    noCourse: "There is no Courses",
    noLevel: "There is no Levels",
    allCourses: "All Courses",
  },
  ar: {
    quizzes: "الاختبارات",
    homeWorks: "الواجبات",
    logoName: "علي أكاديمي",
    dashboard: "لوحة التحكم",
    overview: "نظرة عامة",
    teacherManagement: "إدارة المعلمين",
    categories: "الفئات",
    courses: "الدورات",
    myCourses: "دوراتي",
    coursesWatched: "الدورات التي شاهدتها",
    completedCourses: "الدورات المكتملة",
    currentCourses: "دوراتي الحالية",
    myLectures: "محاضراتي",
    schedule: "الجدول",
    community: "المجتمع",
    invoices: "الفواتير",
    past: "الماضية",
    current: "الحالية",
    upcoming: "القادمة",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    noSubCategory: "لا يوجد فئات فرعية",
    noCategory: "لا يوجد فئات",
    noCourse: "لا يوجد كورسات",
    noLevel: "لا يوجد مستويات",
    allCourses: "جميع الدورات",
  },
  fr: {
    logoName: "Académie Ali",
    dashboard: "Tableau de bord",
    overview: "Vue d'ensemble",
    teacherManagement: "Gestion des enseignants",
    categories: "Catégories",
    courses: "Cours",
    myCourses: "Mes cours",
    coursesWatched: "Cours que j'ai regardés",
    completedCourses: "Cours terminés",
    currentCourses: "Mes cours en cours",
    myLectures: "Mes conférences",
    schedule: "Emploi du temps",
    community: "Communauté",
    invoices: "Factures",
    past: "Passé",
    current: "Actuel",
    upcoming: "À venir",
    settings: "Paramètres",
    logout: "Déconnexion",
    noSubCategory: "Aucune sous-catégorie",
    noCategory: "Aucune catégorie",
    noCourse: "Aucun cours",
    noLevel: "Aucun niveau",
  },
};

// Dashboard
export const DashboardData = {
  en: {
    dailyLessons: "Daily lessons",
    showMoreLessons: "Show more lessons",
    duration: "Duration",
    instructor: "Instructor",
    time: "Time",
    registeredCourses: "Registered courses",
    showMoreCourses: "Show more courses",
    showMoreInvoices: "Show more invoices",
    residual: "Residual",
    rateTheCourses: "Rate The Courses",
    academicAssignment: "Academic assignment",
    received: "Received",
    availableSoon: "Available soon",
    dailySchedule: "Daily schedule",
    quizzes: "Quizzes",
    showMoreQuizzes: "Show more quizzes",
    invoices: "Invoices",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    amountDue: "Amount due",
    paymentNotMade: "Payment has not been made yet",
  },
  ar: {
    dailyLessons: "الدروس اليومية",
    showMoreLessons: "عرض المزيد من الدروس",
    duration: "المدة",
    instructor: "مدرب",
    time: "الوقت",
    registeredCourses: "الدورات المسجلة",
    showMoreCourses: "عرض المزيد من الدورات",
    showMoreInvoices: "عرض المزيد من الفواتير",
    residual: "المتبقي",
    rateTheCourses: "قيم الكورسات",
    academicAssignment: "التكليف الأكاديمي",
    received: "تم الاستلام",
    availableSoon: "قريبا",
    dailySchedule: "الجدول اليومي",
    quizzes: "الاختبارات",
    showMoreQuizzes: "عرض المزيد من الاختبارات",
    invoices: "الفواتير",
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    amountDue: "المبلغ المستحق",
    paymentNotMade: "لم يتم الدفع بعد",
  },
  fr: {
    dailyLessons: "Leçons quotidiennes",
    showMoreLessons: "Voir plus de leçons",
    duration: "Durée",
    instructor: "Instructeur",
    time: "Heure",
    registeredCourses: "Cours inscrits",
    showMoreCourses: "Voir plus de cours",
    residual: "Résiduel",
    rateTheLessons: "Évaluez les leçons",
    academicAssignment: "Devoir académique",
    received: "Reçu",
    availableSoon: "Disponible bientôt",
    dailySchedule: "Emploi du temps quotidien",
    tests: "Tests",
    showMoreTests: "Voir plus de tests",
    invoices: "Factures",
    today: "Aujourd'hui",
    yesterday: "Hier",
    tomorrow: "Demain",
    amountDue: "Montant dû",
    paymentNotMade: "Le paiement n'a pas encore été effectué",
  },
};

// Courses
export const CoursesData = {
  en: {
    live: "Live",
    recorded: "Recorded",
    coursesWatched: "Courses I watched",
    completedCourses: "Completed courses",
    currentCourses: "My current courses",
    sortBy: "Sort by",
    latest: "Latest",
    rating: "Rating",
    price: "Price",
    showLess: "Show less",
    showMore: "Show more",
    registerNow: "Register now",
    completed: "Completed",
    continueWatching: "Continue watching",
  },
  ar: {
    live: "مباشر",
    recorded: "مسجل",
    coursesWatched: "الدورات التي شاهدتها",
    completedCourses: "الدورات المكتملة",
    currentCourses: "دوراتي الحالية",
    sortBy: "فرز حسب",
    latest: "الأحدث",
    rating: "التقييم",
    price: "السعر",
    showLess: "عرض أقل",
    showMore: "عرض المزيد",
    registerNow: "سجل الآن",
    completed: "مكتمل",
    continueWatching: "متابعة المشاهدة",
  },
  fr: {
    coursesWatched: "Cours que j'ai regardés",
    completedCourses: "Cours terminés",
    currentCourses: "Mes cours en cours",
    sortBy: "Trier par",
    latest: "Dernier",
    rating: "Note",
    price: "Prix",
    showLess: "Afficher moins",
    showMore: "Afficher plus",
    registerNow: "Inscrivez-vous maintenant",
    completed: "Terminé",
    continueWatching: "Continuer à regarder",
  },
};

// Settings
export const SettingsData = {
  en: {
    myProfile: "My Profile",
    save: "Save",
    edit: "Edit",
    personalInfo: "Personal Information",
    educationalStage: "Educational Stage",
    institute: "Institute",
    number: "Number",
    email: "Email Address",
    aboutMe: "About Me",
    currentTime: "Current Time",
    subjects: "Subjects",
    certificates: "Certificates and Achievements",
    degree: "Degree",
    viewCertificate: "View Certificate",
    previousProjects: "Previous Projects and Works",
    viewProject: "View Project",
    reviews: "Reviews and Comments",
    viewAllReviews: "View All Reviews",
  },
  ar: {
    myProfile: "ملفي الشخصي",
    save: "حفظ",
    edit: "تعديل",
    personalInfo: "المعلومات الشخصية",
    educationalStage: "المرحلة الدراسية",
    institute: "المعهد",
    number: "الرقم",
    email: "البريد الإلكتروني",
    aboutMe: "نبذة عني",
    currentTime: "التوقيت الحالي",
    subjects: "المواد الدراسية",
    certificates: "الشهادات والإنجازات",
    degree: "الدرجة العلمية",
    viewCertificate: "عرض الشهادة",
    previousProjects: "المشاريع والأعمال السابقة",
    viewProject: "عرض المشروع",
    reviews: "المراجعات والتعليقات",
    viewAllReviews: "عرض جميع المراجعات",
  },
  fr: {
    myProfile: "Mon Profil",
    save: "Enregistrer",
    edit: "Modifier",
    personalInfo: "Informations personnelles",
    educationalStage: "Niveau scolaire",
    institute: "Institut",
    number: "Numéro",
    email: "Adresse e-mail",
    aboutMe: "À propos de moi",
    currentTime: "Heure actuelle",
    subjects: "Matières",
    certificates: "Certificats et réalisations",
    degree: "Diplôme",
    viewCertificate: "Voir le certificat",
    previousProjects: "Projets et travaux précédents",
    viewProject: "Voir le projet",
    reviews: "Avis et commentaires",
    viewAllReviews: "Voir tous les avis",
  },
};

// Table
export const TableData = {
  en: {
    noResults: "No results.",
    rows: "row(s)",
    previous: "Previous",
    next: "Next",
    columns: "Columns",
    filter: "Filter",
  },
  ar: {
    noResults: "لا توجد نتائج.",
    rows: "صف(وف)",
    previous: "السابق",
    next: "التالي",
    columns: "الأعمدة",
    filter: "فلتر",
  },
  fr: {
    noResults: "Aucun résultat.",
    rows: "ligne(s)",
    previous: "Précédent",
    next: "Suivant",
    columns: "Colonnes",
    filter: "Filtre",
  },
};

// Categories
export const CategoriesData = {
  en: {
    courses: "Courses",
    allCategories: "All Categories",
    activeCategories: "Active Categories",
    inactiveCategories: "Inactive Categories",
    categories: "Categories",
    addNewCategory: "Add New Category",
    addCategory: "Add Category",
    editCategory: "Update Category",
    deleteCategory: "Delete Category",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    createdBy: "Created By",
    subCategoryCount: "Sub Category Count",
    actions: "Actions",
    loadingCategories: "Loading Categories",
    categoryCreated: "Category Created",
    categoryUpdated: "Category Updated",
    categoryDeleted: "Category Deleted",
    error: "Error",
    close: "Close",
    confirmDelete:
      "Are you sure you want to delete this category? This action cannot be undone.",
    modifyCategory: "Modify the category details as needed.",
    createCategory: "Easily create and manage a new category.",
    categoriesByTitle: "Categories by Title",
    categoryCreatedDescription:
      "The new category has been successfully added 🎉",
    categoryUpdatedDescription:
      "The category details have been successfully updated ✏️",
    categoryDeletedDescription: "The category has been successfully removed 🗑️",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    descriptionArEn: "Description in Arabic & English",
    deleteConfirmationMessage:
      "You are about to delete this category. This action cannot be undone.",
    actionCannotBeUndone: "This action cannot be undone",
    coursesWillBeDeleted: "courses will be permanently deleted",
    allAssociatedContentRemoved:
      "All associated courses and content will be permanently removed from the system.",
    typeDeleteToConfirm: "Type DELETE to confirm:",
    Cancel: "Cancel",
    showMode: "Show Mode",
    editMode: "Edit Mode",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    Status: "Status",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    subCategories: "Sub Categories",
  },
  ar: {
    courses: "الدورات",
    allCategories: "جميع الفئات",
    activeCategories: "الفئات النشطة",
    inactiveCategories: "الفئات غير النشطة",
    categories: "الفئات",
    addNewCategory: "إضافة فئة جديدة",
    addCategory: "إضافة فئة",
    editCategory: "تعديل الفئة",
    deleteCategory: "حذف الفئة",
    titleEn: "العنوان (الإنجليزية)",
    titleAr: "العنوان (العربية)",
    descriptionEn: "الوصف (الإنجليزية)",
    descriptionAr: "الوصف (العربية)",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    createdBy: "تم الإنشاء بواسطة",
    subCategoryCount: "عدد الفئات الفرعية",
    actions: "الإجراءات",
    loadingCategories: "جارٍ تحميل الفئات",
    categoryCreated: "تم إنشاء الفئة",
    categoryUpdated: "تم تحديث الفئة",
    categoryDeleted: "تم حذف الفئة",
    error: "خطأ",
    close: "إغلاق",
    confirmDelete:
      "هل أنت متأكد أنك تريد حذف هذه الفئة؟ لا يمكن التراجع عن هذا الإجراء.",
    modifyCategory: "قم بتعديل تفاصيل الفئة حسب الحاجة.",
    createCategory: "قم بإنشاء وإدارة فئة جديدة بسهولة.",
    categoriesByTitle: "الفئات حسب العنوان",
    categoryCreatedDescription: "تمت إضافة الفئة الجديدة بنجاح 🎉",
    categoryUpdatedDescription: "تم تحديث تفاصيل الفئة بنجاح ✏️",
    categoryDeletedDescription: "تمت إزالة الفئة بنجاح 🗑️",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    descriptionArEn: "الوصف بالعربية والإنجليزية",
    deleteConfirmationMessage:
      "أنت على وشك حذف هذه الفئة. لا يمكن التراجع عن هذا الإجراء.",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء",
    coursesWillBeDeleted: "سيتم حذف الدورات بشكل دائم",
    allAssociatedContentRemoved:
      "سيتم إزالة جميع الدورات والمحتوى المرتبط بها بشكل دائم من النظام.",
    typeDeleteToConfirm: "اكتب DELETE للتأكيد:",
    Cancel: "إلغاء",
    showMode: "وضع العرض",
    editMode: "وضع التعديل",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    Status: "الحالة",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    subCategories: "الفئات الفرعية",
  },
  fr: {
    allCategories: "Toutes les catégories",
    activeCategories: "Catégories actives",
    inactiveCategories: "Catégories inactives",
    categories: "Catégories",
    addNewCategory: "Ajouter une nouvelle catégorie",
    addCategory: "Ajouter une catégorie",
    editCategory: "Modifier la catégorie",
    deleteCategory: "Supprimer la catégorie",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    descriptionEn: "Description (Anglais)",
    descriptionAr: "Description (Arabe)",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    createdBy: "Créé par",
    courseCount: "Nombre de cours",
    actions: "Actions",
    loadingCategories: "Chargement des catégories",
    categoryCreated: "Catégorie créée",
    categoryUpdated: "Catégorie mise à jour",
    categoryDeleted: "Catégorie supprimée",
    error: "Erreur",
    close: "Fermer",
    confirmDelete:
      "Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action ne peut pas être annulée.",
    modifyCategory: "Modifiez les détails de la catégorie selon vos besoins.",
    createCategory: "Créez et gérez facilement une nouvelle catégorie.",
    categoriesByTitle: "Catégories par titre",
    categoryCreatedDescription:
      "La nouvelle catégorie a été ajoutée avec succès 🎉",
    categoryUpdatedDescription:
      "Les détails de la catégorie ont été mis à jour avec succès ✏️",
    categoryDeletedDescription: "La catégorie a été supprimée avec succès 🗑️",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    descriptionArEn: "Description en arabe et en anglais",
    deleteConfirmationMessage:
      "Vous êtes sur le point de supprimer cette catégorie. Cette action ne peut pas être annulée.",
    actionCannotBeUndone: "Cette action ne peut pas être annulée",
    coursesWillBeDeleted: "les cours seront définitivement supprimés",
    allAssociatedContentRemoved:
      "Tous les cours et contenus associés seront définitivement supprimés du système.",
    typeDeleteToConfirm: "Tapez DELETE pour confirmer:",
    Cancel: "Annuler",
    showMode: "Mode Affichage",
    editMode: "Mode Édition",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    Status: "Statut",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    subCategories: "Sous-catégories",
  },
};

// Sub Categories
export const SubCategoriesData = {
  en: {
    loadingSubCategories: "Loading Sub Categories",
    subCategoryCreated: "Sub Category Created",
    subCategoryCreatedDescription:
      "The new sub category has been successfully added 🎉",
    addNewSubCategory: "Add New Sub Category",
    addSubCategory: "Add Sub Category",
    createSubCategoryDescription:
      "Easily create and manage a new sub category.",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    Status: "Status",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    close: "Close",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    subCategoryDeleted: "Sub Category Deleted",
    subCategoryDeletedDescription:
      "The sub category has been successfully removed 🗑️",
    deleteSubCategory: "Delete Sub Category",
    deleteSubCategoryConfirmation:
      "You are about to delete this sub category. This action cannot be undone.",
    actionCannotBeUndone: "This action cannot be undone",
    subCategoriesWillBeDeleted: "sub categories will be permanently deleted",
    allAssociatedContentRemoved:
      "All associated sub categories and content will be permanently removed from the system.",
    typeDeleteToConfirm: "Type DELETE to confirm:",
    Cancel: "Cancel",
    courseCount: "Course Count",
    subCategoriesByTitle: "Sub Categories by Title",
    updateSubCategory: "Update Sub Category",
    modifySubCategory: "Modify the sub category details as needed.",
    thumbnail: "Thumbnail",
    onlyImages: "Only images with png or jpg extension can be placed.",
    status: "Status",
    selectStatus: "Select status",
    active: "Active",
    inactive: "Inactive",
    generalInformation: "General information",
    titleEn: "Title in English",
    titleAr: "Title in Arabic",
    descriptionAr: "Description in Arabic",
    descriptionEn: "Description in English",
    courses: "Courses",
    error: "Error",
    showMode: "Show Mode",
    editMode: "Edit Mode",
    createdBy: "Created By",
  },
  ar: {
    loadingSubCategories: "جاري تحميل الفئات الفرعية",
    subCategoryCreated: "تم إنشاء الفئة الفرعية",
    subCategoryCreatedDescription: "تمت إضافة الفئة الفرعية الجديدة بنجاح 🎉",
    addNewSubCategory: "إضافة فئة فرعية جديدة",
    addSubCategory: "إضافة فئة فرعية",
    createSubCategoryDescription: "قم بإنشاء وإدارة فئة فرعية جديدة بسهولة.",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    Status: "الحالة",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    close: "إغلاق",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    titleEn: "العنوان (الإنجليزية)",
    titleAr: "العنوان (العربية)",
    descriptionEn: "الوصف (الإنجليزية)",
    descriptionAr: "الوصف (العربية)",
    subCategoryDeleted: "تم حذف الفئة الفرعية",
    subCategoryDeletedDescription: "تمت إزالة الفئة الفرعية بنجاح 🗑️",
    deleteSubCategory: "حذف الفئة الفرعية",
    deleteSubCategoryConfirmation:
      "أنت على وشك حذف هذه الفئة الفرعية. لا يمكن التراجع عن هذا الإجراء.",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء",
    subCategoriesWillBeDeleted: "سيتم حذف الفئات الفرعية بشكل دائم",
    allAssociatedContentRemoved:
      "سيتم إزالة جميع الفئات الفرعية والمحتوى المرتبط بها بشكل دائم من النظام.",
    typeDeleteToConfirm: "اكتب DELETE للتأكيد:",
    Cancel: "إلغاء",
    courseCount: "عدد الدورات",
    subCategoriesByTitle: "الفئات الفرعية حسب العنوان",
    updateSubCategory: "تحديث الفئة الفرعية",
    modifySubCategory: "قم بتعديل تفاصيل الفئة الفرعية حسب الحاجة.",
    thumbnail: "الصورة المصغرة",
    onlyImages: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    status: "الحالة",
    selectStatus: "اختر الحالة",
    active: "نشط",
    inactive: "غير نشط",
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان بالإنجليزية",
    titleAr: "العنوان بالعربية",
    descriptionAr: "الوصف بالعربية",
    descriptionEn: "الوصف بالإنجليزية",
    courses: "الدورات",
    error: "خطأ",
    showMode: "وضع العرض",
    editMode: "وضع التعديل",
    createdBy: "تم الإنشاء بواسطة",
  },
  fr: {
    loadingSubCategories: "Loading Sub Categories",
    subCategoryCreated: "Sous-catégorie créée",
    subCategoryCreatedDescription:
      "La nouvelle sous-catégorie a été ajoutée avec succès 🎉",
    addNewSubCategory: "Ajouter une nouvelle sous-catégorie",
    addSubCategory: "Ajouter une sous-catégorie",
    createSubCategoryDescription:
      "Créez et gérez facilement une nouvelle sous-catégorie.",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    Status: "Statut",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    close: "Fermer",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    descriptionEn: "Description (Anglais)",
    descriptionAr: "Description (Arabe)",
    subCategoryDeleted: "Sous-catégorie supprimée",
    subCategoryDeletedDescription:
      "La sous-catégorie a été supprimée avec succès 🗑️",
    deleteSubCategory: "Supprimer la sous-catégorie",
    deleteSubCategoryConfirmation:
      "Vous êtes sur le point de supprimer cette sous-catégorie. Cette action ne peut pas être annulée.",
    actionCannotBeUndone: "Cette action ne peut pas être annulée",
    subCategoriesWillBeDeleted:
      "les sous-catégories seront définitivement supprimées",
    allAssociatedContentRemoved:
      "Toutes les sous-catégories et le contenu associé seront définitivement supprimés du système.",
    typeDeleteToConfirm: "Tapez DELETE pour confirmer:",
    Cancel: "Annuler",
    courseCount: "Nombre de cours",
    subCategoriesByTitle: "Sous-catégories par titre",
    updateSubCategory: "Mettre à jour la sous-catégorie",
    modifySubCategory:
      "Modifiez les détails de la sous-catégorie selon les besoins.",
    thumbnail: "Vignette",
    onlyImages:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    status: "Statut",
    selectStatus: "Sélectionnez le statut",
    active: "Actif",
    inactive: "Inactif",
    generalInformation: "Informations générales",
    titleEn: "Titre en anglais",
    titleAr: "Titre en arabe",
    descriptionAr: "Description en arabe",
    descriptionEn: "Description en anglais",
    courses: "Cours",
    error: "Erreur",
    showMode: "Mode Affichage",
    editMode: "Mode Édition",
    createdBy: "Créé par",
  },
};

// Course
export const CourseData = {
  en: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "Loading Courses",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    createdBy: "Created By",
    levelCount: "Level Count",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    coursesByTitle: "Courses by Title",
    addCourse: "Add Course",
    easilyCreateAndManageCourse: "Easily create and manage a new Course.",
    thumbnail: "Thumbnail",
    bigImage: "Big Image",
    video: "Video",
    imageExtensionInfo: "Only images with png or jpg extension can be placed.",
    videoExtensionInfo: "Only videos with MP4, WebM extension can be placed.",
    generalInformation: "General Information",
    smallDescription: "Small Description",
    bigDescription: "Big Description",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    selectStatus: "Select Status",
    selectType: "Select Type",
    live: "Live",
    recorded: "Recorded",
    levels: "Levels",
    lessons: "Lessons",
    // Delete dialog texts
    deleteCourse: "Delete Course",
    deleteCourseDialogTitle: "Delete Course",
    deleteCourseDialogDescription:
      "You are about to delete this Course. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    levelsWillBeDeleted: "levels will be permanently deleted",
    associatedContentRemoval:
      "All associated levels and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
    cancel: "Cancel",
    // Toast and error messages
    courseCreatedToast: "Course Created",
    courseCreatedDescription: "The new course has been successfully added 🎉",
    courseDeletedToast: "Course Deleted",
    courseDeletedDescription: "The course has been successfully removed 🗑️",
    error: "Error",
    // AdminViewCourses additional texts
    updateCourse: "Update Course",
    viewCourse: "View Course",
    courseUpdatedToast: "Course Updated",
    courseUpdatedDescription:
      "The course details have been successfully updated ✏️",
    editMode: "Edit Mode",
    showMode: "Show Mode",
    studyEnroll: "Study Enroll",
  },
  ar: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "جاري تحميل الكورسات",
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    createdBy: "تم الإنشاء بواسطة",
    levelCount: "عدد المستويات",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    actions: "الإجراءات",
    coursesByTitle: "الدورات حسب العنوان",
    addCourse: "إضافة دورة",
    easilyCreateAndManageCourse: "أنشئ دورة جديدة وقم بإدارتها بسهولة.",
    thumbnail: "الصورة المصغرة",
    bigImage: "صورة كبيرة",
    video: "فيديو",
    imageExtensionInfo: "يمكن استخدام الصور ذات امتداد png أو jpg فقط.",
    videoExtensionInfo: "يمكن استخدام الفيديوهات ذات امتداد MP4 أو WebM فقط.",
    generalInformation: "معلومات عامة",
    smallDescription: "وصف قصير",
    bigDescription: "وصف طويل",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    selectStatus: "اختر الحالة",
    selectType: "اختر النوع",
    live: "مباشر",
    recorded: "مسجل",
    levels: "المستويات",
    lessons: "الدروس",
    // Delete dialog texts
    deleteCourse: "حذف الدورة",
    deleteCourseDialogTitle: "حذف الدورة",
    deleteCourseDialogDescription:
      "أنت على وشك حذف هذه الدورة. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    levelsWillBeDeleted: "سيتم حذف المستويات نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع المستويات والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
    cancel: "إلغاء",
    // Toast and error messages
    courseCreatedToast: "تم إنشاء الدورة",
    courseCreatedDescription: "تم إضافة الدورة الجديدة بنجاح 🎉",
    courseDeletedToast: "تم حذف الدورة",
    courseDeletedDescription: "تمت إزالة الدورة بنجاح 🗑️",
    error: "خطأ",
    // AdminViewCourses additional texts
    updateCourse: "تحديث الدورة",
    viewCourse: "عرض الدورة",
    courseUpdatedToast: "تم تحديث الدورة",
    courseUpdatedDescription: "تم تحديث تفاصيل الدورة بنجاح ✏️",
    editMode: "وضع التعديل",
    showMode: "وضع العرض",
    studyEnroll: "التسجيل الدراسي",
  },
  fr: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "Loading Courses",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    createdBy: "Créé par",
    levelCount: "Nombre de niveaux",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    actions: "Actions",
    coursesByTitle: "Cours par Titre",
    addCourse: "Ajouter un cours",
    easilyCreateAndManageCourse: "Créez et gérez facilement un nouveau cours.",
    thumbnail: "Vignette",
    bigImage: "Grande image",
    video: "Vidéo",
    imageExtensionInfo:
      "Seules les images au format png ou jpg sont acceptées.",
    videoExtensionInfo:
      "Seules les vidéos au format MP4 ou WebM sont acceptées.",
    generalInformation: "Informations générales",
    smallDescription: "Petite description",
    bigDescription: "Grande description",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    selectStatus: "Sélectionner le statut",
    selectType: "Sélectionner le type",
    live: "En direct",
    recorded: "Enregistré",
    levels: "Niveaux",
    lessons: "Leçons",
    // Delete dialog texts
    deleteCourse: "Supprimer le cours",
    deleteCourseDialogTitle: "Supprimer le cours",
    deleteCourseDialogDescription:
      "Vous êtes sur le point de supprimer ce cours. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    levelsWillBeDeleted: "les niveaux seront supprimés définitivement",
    associatedContentRemoval:
      "Tous les niveaux et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
    cancel: "Annuler",
    // Toast and error messages
    courseCreatedToast: "Cours créé",
    courseCreatedDescription: "Le nouveau cours a été ajouté avec succès 🎉",
    courseDeletedToast: "Cours supprimé",
    courseDeletedDescription: "Le cours a été supprimé avec succès 🗑️",
    error: "Erreur",
    // AdminViewCourses additional texts
    updateCourse: "Mettre à jour le cours",
    courseUpdatedToast: "Cours mis à jour",
    courseUpdatedDescription:
      "Les détails du cours ont été mis à jour avec succès ✏️",
    editMode: "Mode édition",
    showMode: "Mode d'affichage",
  },
};

// Level
export const LevelData = {
  en: {
    viewLessons: "View lessons",
    edit: "Edit",
    editLevel: "Edit Level",
    editLevelDescription: "Modify the level details as needed.",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    description: "Description (English) & Description (Arabic)",
    levelUpdatedToast: "Level Updated",
    levelUpdatedDescription:
      "The level details have been successfully updated ✏️",
    addLevel: "Add Level",
    addLevelDescription: "Easily create and manage a new level.",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    delete: "Delete",
    deleteLevel: "Delete level",
    deleteLevelDialogTitle: "Delete Level",
    deleteLevelDialogDescription:
      "You are about to delete this level. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    lessonsWillBeDeleted: "lessons will be permanently deleted",
    associatedContentRemoval:
      "All associated lessons and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
    cancel: "Cancel",
  },
  ar: {
    viewLessons: "عرض الدروس",
    edit: "تعديل",
    editLevel: "تعديل المستوى",
    editLevelDescription: "قم بتعديل تفاصيل المستوى حسب الحاجة.",
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    description: "الوصف (بالإنجليزية) & الوصف (بالعربية)",
    levelUpdatedToast: "تم تحديث المستوى",
    levelUpdatedDescription: "تم تحديث تفاصيل المستوى بنجاح ✏️",
    addLevel: "إضافة مستوى",
    addLevelDescription: "أنشئ مستوى جديد وأدره بسهولة.",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    delete: "حذف",
    deleteLevel: "حذف المستوى",
    deleteLevelDialogTitle: "حذف المستوى",
    deleteLevelDialogDescription:
      "أنت على وشك حذف هذا المستوى. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    lessonsWillBeDeleted: "سيتم حذف الدروس نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع الدروس والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
    cancel: "إلغاء",
  },
  fr: {
    viewLessons: "Voir les leçons",
    edit: "Modifier",
    editLevel: "Modifier le niveau",
    editLevelDescription: "Modifiez les détails du niveau selon les besoins.",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    description: "Description (Anglais) & Description (Arabe)",
    levelUpdatedToast: "Niveau mis à jour",
    levelUpdatedDescription:
      "Les détails du niveau ont été mis à jour avec succès ✏️",
    addLevel: "Ajouter un niveau",
    addLevelDescription: "Créez et gérez facilement un nouveau niveau.",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    delete: "Supprimer",
    deleteLevel: "Supprimer le niveau",
    deleteLevelDialogTitle: "Supprimer le niveau",
    deleteLevelDialogDescription:
      "Vous êtes sur le point de supprimer ce niveau. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    lessonsWillBeDeleted: "les leçons seront supprimées définitivement",
    associatedContentRemoval:
      "Tous les leçons et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
    cancel: "Annuler",
  },
};

// Lesson
export const LessonData = {
  en: {
    // TableLessons texts
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    subLessonCount: "Sub Lesson Count",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    tableTitle: "Lessons by Title",
    // DrawerAddLesson texts
    addLesson: "Add Lesson",
    addLessonDescription: "Easily create and manage a new Lesson.",
    lessonCreatedToast: "Lesson Created",
    lessonCreatedDescription: "The new lesson has been successfully added 🎉",
    thumbnail: "Thumbnail",
    bigImage: "Big Image",
    video: "Video",
    imageExtensionInfo: "Only images with png or jpg extension can be placed.",
    videoExtensionInfo: "Only videos with MP4, WebM extension can be placed.",
    generalInformation: "General information",
    smallDescription: "Small Description",
    bigDescription: "Big Description",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    selectStatus: "Select status",
    status: "Status",
    type: "Type",
    selectType: "Select type",
    live: "Live",
    recorded: "Recorded",
    cancel: "Close",
    // DialogDeleteLessons texts
    deleteLesson: "Delete Lesson",
    deleteLessonDialogTitle: "Delete Lesson",
    deleteLessonDialogDescription:
      "You are about to delete this lesson. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    studentsWillBeDeleted: "Students will be permanently deleted",
    associatedContentRemoval:
      "All associated lessons and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
  },
  ar: {
    // TableLessons texts
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    subLessonCount: "عدد الدروس الفرعية",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    actions: "الإجراءات",
    tableTitle: "الدروس حسب العنوان",
    // DrawerAddLesson texts
    addLesson: "إضافة درس",
    addLessonDescription: "أنشئ درسًا جديدًا وقم بإدارته بسهولة.",
    lessonCreatedToast: "تم إنشاء الدرس",
    lessonCreatedDescription: "تمت إضافة الدرس الجديد بنجاح 🎉",
    thumbnail: "الصورة المصغرة",
    bigImage: "صورة كبيرة",
    video: "فيديو",
    imageExtensionInfo: "يمكن استخدام الصور ذات امتداد png أو jpg فقط.",
    videoExtensionInfo: "يمكن استخدام الفيديوهات ذات امتداد MP4 أو WebM فقط.",
    generalInformation: "معلومات عامة",
    smallDescription: "وصف قصير",
    bigDescription: "وصف طويل",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    status: "الحالة",
    type: "نوع",
    selectStatus: "اختر الحالة",
    selectType: "اختر النوع",
    live: "مباشر",
    recorded: "مسجل",
    cancel: "إلغاء",
    // DialogDeleteLessons texts
    deleteLesson: "حذف الدرس",
    deleteLessonDialogTitle: "حذف الدرس",
    deleteLessonDialogDescription:
      "أنت على وشك حذف هذا الدرس. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    studentsWillBeDeleted: "سيتم حذف الطلاب نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع الدروس والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
  },
  fr: {
    // TableLessons texts
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    subLessonCount: "Nombre de sous-leçons",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    actions: "Actions",
    tableTitle: "Leçons par titre",
    // DrawerAddLesson texts
    addLesson: "Ajouter une leçon",
    addLessonDescription: "Créez et gérez facilement une nouvelle leçon.",
    lessonCreatedToast: "Leçon créée",
    lessonCreatedDescription: "La nouvelle leçon a été ajoutée avec succès 🎉",
    thumbnail: "Vignette",
    bigImage: "Grande image",
    video: "Vidéo",
    imageExtensionInfo:
      "Seules les images au format png ou jpg sont acceptées.",
    videoExtensionInfo:
      "Seules les vidéos au format MP4 ou WebM sont acceptées.",
    generalInformation: "Informations générales",
    smallDescription: "Petite description",
    bigDescription: "Grande description",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    status: "Statut",
    type: "Type",
    selectStatus: "Sélectionnez le statut",
    selectType: "Sélectionnez le type",
    live: "En direct",
    recorded: "Enregistré",
    cancel: "Annuler",
    // DialogDeleteLessons texts
    deleteLesson: "Supprimer la leçon",
    deleteLessonDialogTitle: "Supprimer la leçon",
    deleteLessonDialogDescription:
      "Vous êtes sur le point de supprimer cette leçon. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    subLessonsWillBeDeleted: "Les sous-leçons seront définitivement supprimées",
    associatedContentRemoval:
      "Tous les leçons et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
  },
};

// Group
export const GroupLang = {
  en: {
    studyEnrollTitle: "Study Enroll by name",
    name: "Name",
    teacher: "Teacher",
    studentCount: "Student Count",
    type: "Type",
    groups: "Groups",
    individual: "Individual",
    actions: "Actions",
    deleteLesson: "Delete Lesson",
    deleteLessonDialogDescription:
      "Are you sure you want to delete this lesson? All associated content will be removed.",
    error: "Error",
    deleteLessonDialogTitle: "Delete Lesson",
    deleteWarning: "This will delete the lesson permanently.",
    studentsWillBeDeleted: "Students will also be deleted",
    associatedContentRemoval: "All associated content will be removed.",
    typeToConfirm: "Type DELETE to confirm",
    cancel: "Cancel",
    addLesson: "Add Lesson",
    addLessonDescription: "Fill in the details to add a new lesson.",
    lessonCreatedToast: "Lesson Created",
    lessonCreatedDescription: "The lesson was created successfully.",
    thumbnail: "Thumbnail",
    imageExtensionInfo: "Supported image formats: jpg, png, etc.",
    bigImage: "Big Image",
    video: "Video",
    videoExtensionInfo: "Supported video formats: mp4, etc.",
    generalInformation: "General Information",
    titleEn: "Title (English)",
    enterTitleEn: "Enter the title in English",
    titleAr: "Title (Arabic)",
    enterTitleAr: "Enter the title in Arabic",
    status: "Status",
    selectStatus: "Select Status",
    active: "Active",
    inactive: "Inactive",
    selectType: "Select Type",
    live: "Live",
    recorded: "Recorded",
  },
  ar: {
    studyEnrollTitle: "تسجيل الدراسة حسب الاسم",
    name: "الاسم",
    teacher: "المعلم",
    studentCount: "عدد الطلاب",
    type: "النوع",
    groups: "مجموعات",
    individual: "فردي",
    actions: "الإجراءات",
    deleteLesson: "حذف الدرس",
    deleteLessonDialogDescription:
      "هل أنت متأكد أنك تريد حذف هذا الدرس؟ سيتم إزالة جميع المحتويات المرتبطة.",
    error: "خطأ",
    deleteLessonDialogTitle: "حذف الدرس",
    deleteWarning: "سيؤدي ذلك إلى حذف الدرس نهائيًا.",
    studentsWillBeDeleted: "سيتم حذف الطلاب أيضًا",
    associatedContentRemoval: "سيتم إزالة جميع المحتويات المرتبطة.",
    typeToConfirm: "اكتب DELETE للتأكيد",
    cancel: "إلغاء",
    addLesson: "إضافة درس",
    addLessonDescription: "املأ التفاصيل لإضافة درس جديد.",
    lessonCreatedToast: "تم إنشاء الدرس",
    lessonCreatedDescription: "تم إنشاء الدرس بنجاح.",
    thumbnail: "صورة مصغرة",
    imageExtensionInfo: "الصيغ المدعومة: jpg, png, إلخ.",
    bigImage: "صورة كبيرة",
    video: "فيديو",
    videoExtensionInfo: "الصيغ المدعومة: mp4, إلخ.",
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان (إنجليزي)",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    titleAr: "العنوان (عربي)",
    enterTitleAr: "أدخل العنوان بالعربية",
    status: "الحالة",
    selectStatus: "اختر الحالة",
    active: "نشط",
    inactive: "غير نشط",
    selectType: "اختر النوع",
    live: "مباشر",
    recorded: "مسجل",
  },
};

// Lesson Of Teacher
export const LessonTeacherData = {
  en: {
    // AllLessons texts
    loadingLessonsTitle: "Loading Lessons",
    lessonsHeading: "Lessons",
    lessonsByTitle: "Lessons by Title",
    columnTitleEn: "Title (English)",
    columnTitleAr: "Title (Arabic)",
    columnGroup: "Group",
    columnCreated: "Created",
    columnStatus: "Status",
    columnActions: "Actions",
    activeStatus: "Active",
    inactiveStatus: "Inactive",
    unknownStatus: "Unknown",
    toastError: "Error",

    // DialogDeleteLesson texts
    deleteConfirmationMessage:
      "Are you sure you want to delete this lesson? This action cannot be undone.",
    typeDeleteToConfirm: "Type DELETE to confirm",
    cancel: "Cancel",
    deleteLesson: "Delete Lesson",
    toastLessonDeletedTitle: "Lesson Deleted",
    toastLessonDeletedDescription:
      "The lesson has been successfully removed 🗑️",

    // DrawerEditLesson texts
    editLessonHeading: "Edit Lesson",
    editLessonDescription: "Modify the lesson details as needed.",
    editLessonButton: "Edit Lesson",
    editMode: "Edit Mode",
    showMode: "Show Mode",
    Thumbnail: "Thumbnail",
    imageExtensionMessage: "Supported image formats: jpg, png, etc.",
    status: "Status",
    selectStatus: "Select Status",
    active: "Active",
    inactive: "Inactive",
    generalInformation: "General Information",
    titleEn: "Title (English)",
    enterTitleEn: "Enter the title in English",
    titleAr: "Title (Arabic)",
    enterTitleAr: "Enter the title in Arabic",
    descriptionArEn: "Description",
    toastLessonUpdatedTitle: "Lesson Updated",
    toastLessonUpdatedDescription:
      "The lesson details have been successfully updated ✏️",
  },
  ar: {
    // AllLessons texts
    loadingLessonsTitle: "تحميل الدروس",
    lessonsHeading: "الدروس",
    lessonsByTitle: "الدروس حسب العنوان",
    columnTitleEn: "العنوان (إنجليزي)",
    columnTitleAr: "العنوان (عربي)",
    columnGroup: "المجموعة",
    columnCreated: "تاريخ الإنشاء",
    columnStatus: "الحالة",
    columnActions: "الإجراءات",
    activeStatus: "نشط",
    inactiveStatus: "غير نشط",
    unknownStatus: "غير معروف",
    toastError: "خطأ",

    // DialogDeleteLesson texts
    deleteConfirmationMessage:
      "هل أنت متأكد أنك تريد حذف هذا الدرس؟ لا يمكن التراجع عن هذا الإجراء.",
    typeDeleteToConfirm: "اكتب DELETE للتأكيد",
    cancel: "إلغاء",
    deleteLesson: "حذف الدرس",
    toastLessonDeletedTitle: "تم حذف الدرس",
    toastLessonDeletedDescription: "تم إزالة الدرس بنجاح 🗑️",

    // DrawerEditLesson texts
    editLessonHeading: "تعديل الدرس",
    editLessonDescription: "قم بتعديل تفاصيل الدرس حسب الحاجة.",
    editLessonButton: "تعديل الدرس",
    editMode: "وضع التعديل",
    showMode: "وضع العرض",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "الصيغ المدعومة: jpg, png, إلخ.",
    status: "الحالة",
    selectStatus: "اختر الحالة",
    active: "نشط",
    inactive: "غير نشط",
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان (إنجليزي)",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    titleAr: "العنوان (عربي)",
    enterTitleAr: "أدخل العنوان بالعربية",
    descriptionArEn: "الوصف",
    toastLessonUpdatedTitle: "تم تحديث الدرس",
    toastLessonUpdatedDescription: "تم تحديث تفاصيل الدرس بنجاح ✏️",
  },
};

// Sub Lesson
export const SubLessonData = {
  en: {
    expireDate: "Expire Date",
    maxFiles: "Max Files",
    showHomework: "Show Homeworks",
    answerHomeWork: "Answer Home Work",
    dialogAnswerTitle: "Add Answers",
    titleLabel: "Title",
    placeholderTitleFile: "Enter Title File",
    addAnswer: "Add Answers",
    toastAnswerAdded: "Answer Added",
    toastAnswerAddedDescription:
      "The homework answer has been successfully added 🎉",

    deleteAnswerTitle: "Delete Answer",
    dialogDeleteDescription:
      "Are you sure you want to delete this answer? This action cannot be undone.",
    typeToConfirmDelete: 'Type "DELETE" to confirm',
    cancel: "Cancel",
    deleteAnswer: "Delete Answer",
    confirmationWord: "DELETE",

    // Loader and headings
    loaderTitle: "Loading Sub Lesson",
    viewLessonHeading: "View Lesson",
    // Tabs titles (you can also use an array if needed)
    tabsListTitles: [
      { title: "Lesson Content", value: "content" },
      { title: "Description", value: "description" },
      { title: "Homeworks", value: "homeWork" },
      { title: "Documents", value: "documents" },
      { title: "Quizs", value: "quizs" },
    ],
    // Button and navigation texts
    back: "Back",
    previous: "Previous",
    next: "Next",
    watch: "Watch",
    // Content Tab texts
    noContentMessage: "No video content available",
    // DrawerAddContent texts
    addContent: "Add Content",
    addContentDescription: "Easily create and manage a new Content.",
    addContentButton: "Add Content",
    // DialogDeleteContent texts
    deleteContent: "Delete Content",
    contentDeleteConfirm:
      "Are you sure you want to delete this content? This action cannot be undone.",
    typeToConfirmDelete: "Type DELETE to confirm:",
    // Toasts for content deletion/creation
    contentDeletedToastTitle: "Content Deleted",
    contentDeletedToastDescription:
      "The content has been successfully removed 🗑️",
    contentCreatedToastTitle: "Content Created",
    contentCreatedToastDescription:
      "The new content has been successfully added 🎉",
    // Video & Live texts
    live: "Live",
    video: "Video",
    onlyVideosMessage: "Only videos with MP4, WebM extension can be placed.",
    // General Information texts
    generalInformation: "General Information",
    titleEn: "Title (English)",
    enterTitleEn: "Enter title in English",
    titleAr: "Title (Arabic)",
    enterTitleAr: "Enter title in Arabic",
    descriptionLabel: "Description (English) & (Arabic)",
    // Messages Tab text
    messageButton: "Message",
    cancel: "Cancel",
    generalInformation: "General Information",
    titleEn: "Title (English)",
    enterTitleEn: "Enter title in English",
    titleAr: "Title (Arabic)",
    enterTitleAr: "Enter title in Arabic",
    descriptionLabel: "Description (English) & (Arabic)",
    onlyVideosMessage: "Only videos with MP4, WebM extension can be placed.",

    // For editing content
    editContent: "Edit Content",
    modifyContentDescription: "Modify the content details as needed",
    editContentButton: "Edit Content",
    liveLink: "Live Link",
    enterLiveLink: "Enter Link of live",

    // For editing documents
    editDocument: "Edit Document",
    modifyDocumentDescription: "Modify the document details as needed",
    editDocumentButton: "Edit Document",

    // For adding documents
    addDocument: "Add Document",
    addDocumentDescription: "Easily create and manage a new document.",

    // For document deletion
    deleteDocument: "Delete Document",
    documentDeleteConfirm:
      "Are you sure you want to delete this document? This action cannot be undone.",
    typeToConfirmDelete: "Type DELETE to confirm:",

    // Toast messages for document update
    documentUpdatedToastTitle: "Document Updated",
    documentUpdatedToastDescription:
      "The document details have been successfully updated ✏️",

    // (Optional) No documents available message
    noDocuments: "No documents available.",

    // Label for Files (if needed)
    files: "Files",

    // Home Work Tab
    homeworkTabTitle: "Home Work",
    homeworkShowAnswers: "Show Answers",
    homeworkExpireDateTooltip: "Expire Date",
    homeworkMaxFilesTooltip: "Max Files",
    fileLabelSingular: "File",
    fileLabelPlural: "Files",
    selectLesson: "Select Lesson",
    expireDate: "Expire Date",
    maxItems: "Max Items",
    score: "Score",

    // Drawer Add Home Work
    addHomeWork: "Add Home Work",
    addHomeWorkDescription: "Easily create and manage a new home work.",
    addHomeWorkButton: "Add Home Work",

    // Drawer Edit Home Work
    editHomeWork: "Edit Home Work",
    modifyHomeWorkDescription: "Modify the home work details as needed",
    editHomeWorkButton: "Edit Home Work",

    // Dialog Delete Home Work
    deleteHomeWork: "Delete Home Work",
    deleteQuiz: "Delete Quiz",
    deleteHomeWorkConfirm:
      "Are you sure you want to delete this home work? This action cannot be undone.",
    typeToConfirmDelete: "Type DELETE to confirm:",

    // Quiz Tab
    quizNoQuizzes: "No quizzes available.",
    quizShowAnswers: "Show Answers",
    quizUntitled: "Untitled Quiz",
    addQuiz: "Add Quiz",
    selectCategory: "Select Category",
    selectCourse: "Select Course",
    // Quiz Page Keys
    addQuizTitle: "Add Quiz",
    addQuizDescription: "Easily create and manage a new quiz",
    generalInformation: "General information",
    durationLabel: "Duration",
    dateRangeLabel: "Start Date & End Date",
    submitQuiz: "Add Quiz",
    loadingQuiz: "Loading quiz...",
    // Quiz keys
    editQuizTitle: "Edit Quiz",
    editQuizDescription: "Easily edit and manage your quiz",
    generalInformation: "General information",
    durationLabel: "Duration",
    dateRangeLabel: "Start Date & End Date",
    submitQuiz: "Save Changes",
    loadingQuiz: "Loading quiz...",
    validationError: "Validation Error",
    checkFormForErrors: "Please check the form for errors",
    quizUpdatedToastTitle: "Success",
    quizUpdatedToastDescription: "Quiz updated successfully",
    // Quiz Answer
    loadingAttemptQuiz: "Loading Attempt Quiz",
    loadingHomeworkQuiz: "Loading Homework Quiz",
    quizAnswersTitle: "Quiz Answers",
    quizHomeworksTitle: "Quiz Homeworks",
    usersByName: "Users By Name & Email",
    name: "Name",
    email: "Email",
    phone: "Phone",
    score: "Score",
    showAnswers: "Show Answers",
    reviewTestForStudent: "Review a test for this student",
    close: "Close",
    showDegree: "Show Degree",
    showAnswer: "Show Answer",
    active: "Active",
    inactive: "In Active",
    // -- NEW KEYS FOR FILES DIALOG (Teacher Assignments) --
    dialogFilesTitle: "Files",
    dialogFilesDescription: "Click on a file to download or preview.",
    noFilesAvailable: "No files available",
    // (You can reuse "cancel" or add a dedicated close key)
    close: "Close",

    // -- NEW KEYS FOR ASSIGNMENTS (Teacher Assignments) --
    assignmentsTitle: "Home Works",
    tableAssignmentsTitle: "Home Works by name, score",
    columnTitleEn: "Title (English)",
    columnTitleAr: "Title (Arabic)",
    columnScore: "Score",
    columnStartDate: "Start Date",
    columnEndDate: "End Date",
    columnFilesCount: "Files Count",
    columnActions: "Actions",

    // -- NEW KEYS FOR QUIZZES (Teacher Quizez) --
    quizezHeading: "Quizez",
    tableQuizezTitle: "Quizez by name, score",
    columnDuration: "Duration",
    columnStartDateQuiz: "Start Date",
    columnEndDateQuiz: "End Date",
    columnStartTime: "Start Time",
    columnEndTime: "End Time",
    columnQuizTarget: "Quiz Target",

    // -- NEW KEYS FOR STUDENTS (Teacher Students) --
    studentsHeading: "Students",
    tableStudentsTitle: "Student by Name",
    columnStudentName: "Student Name",
    columnEmailAddress: "Email Address",
    columnPhone: "Phone",
    columnRegisterDate: "Register Date",

    homeworkShowAnswers: "Show Answers",
    dialogFilesTitle: "Answer Files",
    dialogFilesDescription:
      "Here you can download or view your submitted answers.",
    loading: "Loading...",
    close: "Close",
  },
  ar: {
    expireDate: "تاريخ الانتهاء",
    maxFiles: "اقصي عدد للملفات",
    showHomework: "اظهار الواجبات",
    answerHomeWork: "إجابة الواجب",
    dialogAnswerTitle: "إضافة إجابة",
    titleLabel: "العنوان",
    placeholderTitleFile: "أدخل عنوان الملف",
    addAnswer: "إضافة الإجابة",
    toastAnswerAdded: "تمت إضافة الإجابة",
    toastAnswerAddedDescription: "تمت إضافة إجابة الواجب بنجاح 🎉",

    deleteAnswerTitle: "حذف الإجابة",
    dialogDeleteDescription:
      "هل أنت متأكد من رغبتك في حذف هذه الإجابة؟ لا يمكن التراجع عن هذا الإجراء.",
    typeToConfirmDelete: 'اكتب "DELETE" للتأكيد',
    cancel: "إلغاء",
    deleteAnswer: "حذف الإجابة",
    confirmationWord: "DELETE", // placeholder stays in English

    // Loader and headings
    loaderTitle: "تحميل الدرس الفرعي",
    viewLessonHeading: "عرض الدرس",
    // Tabs titles
    tabsListTitles: [
      { title: "محتوى الدرس", value: "content" },
      { title: "الوصف", value: "description" },
      { title: "الواجبات", value: "homeWork" },
      { title: "المستندات", value: "documents" },
      { title: "الاختبارات", value: "quizs" },
    ],
    // Button and navigation texts
    back: "رجوع",
    previous: "السابق",
    next: "التالي",
    watch: "مشاهدة",
    // Content Tab texts
    noContentMessage: "لا يوجد محتوى فيديو متاح",
    // DrawerAddContent texts
    addContent: "اضافة محتوى",
    addContentDescription: "قم بإنشاء وإدارة محتوى جديد بسهولة.",
    addContentButton: "اضافة محتوى",
    // DialogDeleteContent texts
    deleteContent: "حذف المحتوى",
    contentDeleteConfirm:
      "هل أنت متأكد أنك تريد حذف هذا المحتوى؟ لا يمكن التراجع عن هذا الإجراء.",
    typeToConfirmDelete: "اكتب DELETE للتأكيد:",
    // Toasts for content deletion/creation
    contentDeletedToastTitle: "تم حذف المحتوى",
    contentDeletedToastDescription: "تم إزالة المحتوى بنجاح 🗑️",
    contentCreatedToastTitle: "تم إنشاء المحتوى",
    contentCreatedToastDescription: "تم إضافة المحتوى الجديد بنجاح 🎉",
    // Video & Live texts
    live: "مباشر",
    video: "فيديو",
    onlyVideosMessage: "يمكن تحميل الفيديوهات بصيغة MP4, WebM فقط.",
    // General Information texts
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان (إنجليزي)",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    titleAr: "العنوان (عربي)",
    enterTitleAr: "أدخل العنوان بالعربية",
    descriptionLabel: "الوصف (إنجليزي) & (عربي)",
    // Messages Tab text
    messageButton: "مراسلة",
    cancel: "اغلاق",
    cancel: "إلغاء",
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان (إنجليزي)",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    titleAr: "العنوان (عربي)",
    enterTitleAr: "أدخل العنوان بالعربية",
    descriptionLabel: "الوصف (إنجليزي) & (عربي)",
    onlyVideosMessage: "يمكن تحميل الفيديوهات بصيغة MP4, WebM فقط.",

    // For editing content
    editContent: "تعديل المحتوى",
    modifyContentDescription: "قم بتعديل تفاصيل المحتوى حسب الحاجة",
    editContentButton: "تعديل المحتوى",
    liveLink: "رابط البث المباشر",
    enterLiveLink: "أدخل رابط البث المباشر",

    // For editing documents
    editDocument: "تعديل المستند",
    modifyDocumentDescription: "قم بتعديل تفاصيل المستند حسب الحاجة",
    editDocumentButton: "تعديل المستند",

    // For adding documents
    addDocument: "إضافة مستند",
    addDocumentDescription: "قم بإنشاء وإدارة مستند جديد بسهولة.",

    // For document deletion
    deleteDocument: "حذف المستند",
    documentDeleteConfirm:
      "هل أنت متأكد أنك تريد حذف هذا المستند؟ لا يمكن التراجع عن هذا الإجراء.",
    typeToConfirmDelete: "اكتب DELETE للتأكيد:",

    // Toast messages for document update
    documentUpdatedToastTitle: "تم تحديث المستند",
    documentUpdatedToastDescription: "تم تحديث تفاصيل المستند بنجاح ✏️",

    // (Optional) No documents available message
    noDocuments: "لا يوجد مستندات متاحة.",

    // Label for Files (if needed)
    files: "ملفات",

    homeworkTabTitle: "الواجبات",
    homeworkShowAnswers: "عرض الإجابات",
    homeworkExpireDateTooltip: "تاريخ الانتهاء",
    homeworkMaxFilesTooltip: "عدد الملفات المسموح",
    fileLabelSingular: "ملف",
    fileLabelPlural: "ملفات",
    selectLesson: "اختر الدرس",
    expireDate: "تاريخ الانتهاء",
    maxItems: "الحد الأقصى للملفات",
    score: "الدرجة",

    // Drawer Add Home Work
    addHomeWork: "إضافة واجبات",
    addHomeWorkDescription: "قم بإنشاء وإدارة واجب جديد بسهولة.",
    addHomeWorkButton: "إضافة واجبات",

    // Drawer Edit Home Work
    editHomeWork: "تعديل الواجب",
    modifyHomeWorkDescription: "قم بتعديل تفاصيل الواجب حسب الحاجة",
    editHomeWorkButton: "تعديل الواجب",

    // Dialog Delete Home Work
    deleteHomeWork: "حذف الواجب",
    deleteQuiz: "حذف الاختبار",
    deleteHomeWorkConfirm:
      "هل أنت متأكد أنك تريد حذف هذا الواجب؟ لا يمكن التراجع عن هذا الإجراء.",
    typeToConfirmDelete: "اكتب DELETE للتأكيد:",

    // Quiz Tab
    quizNoQuizzes: "لا توجد اختبارات متاحة.",
    quizShowAnswers: "عرض الإجابات",
    quizUntitled: "اختبار بدون عنوان",
    addQuiz: "إضافة اختبار",
    addQuizTitle: "إضافة اختبار",
    addQuizDescription: "إنشاء وإدارة اختبار جديد بسهولة",
    generalInformation: "معلومات عامة",
    durationLabel: "المدة",
    dateRangeLabel: "تاريخ البداية والنهاية",
    submitQuiz: "إضافة اختبار",
    loadingQuiz: "جاري تحميل الاختبار...",
    selectCategory: "اختر الفئة",
    selectCourse: "اختر الدورة",
    // Edit
    editQuizTitle: "تعديل الاختبار",
    editQuizDescription: "تعديل وإدارة الاختبار بسهولة",
    generalInformation: "معلومات عامة",
    durationLabel: "المدة",
    dateRangeLabel: "تاريخ البداية والنهاية",
    submitQuiz: "حفظ التغييرات",
    loadingQuiz: "جاري تحميل الاختبار...",
    validationError: "خطأ في التحقق",
    checkFormForErrors: "يرجى مراجعة النموذج للأخطاء",
    quizUpdatedToastTitle: "نجاح",
    quizUpdatedToastDescription: "تم تحديث الاختبار بنجاح",
    // Quiz Answer
    loadingAttemptQuiz: "جاري تحميل إجابات الاختبار",
    loadingHomeworkQuiz: "جاري تحميل إجابات الواجبات",
    quizAnswersTitle: "إجابات الاختبار",
    quizHomeworksTitle: "اجابات الواجبات",
    usersByName: "المستخدمين حسب الاسم أو الاميل",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    score: "الدرجة",
    showAnswers: "عرض الإجابات",
    reviewTestForStudent: "مراجعة الاختبار لهذا الطالب",
    close: "اغلاق",
    showDegree: "اظهار الدرجة",
    showAnswer: "اظهار الاجابة",
    active: "مفعل",
    inactive: "غير مفعل",
    // -- NEW KEYS FOR FILES DIALOG (Teacher Assignments) --
    dialogFilesTitle: "ملفات",
    dialogFilesDescription: "انقر على الملف للتنزيل أو العرض المسبق.",
    noFilesAvailable: "لا توجد ملفات",
    close: "إغلاق",

    // -- NEW KEYS FOR ASSIGNMENTS (Teacher Assignments) --
    assignmentsTitle: "الواجبات",
    tableAssignmentsTitle: "الواجبات حسب الاسم والدرجة",
    columnTitleEn: "العنوان (إنجليزي)",
    columnTitleAr: "العنوان (عربي)",
    columnScore: "الدرجة",
    columnStartDate: "تاريخ البداية",
    columnEndDate: "تاريخ النهاية",
    columnFilesCount: "عدد الملفات",
    columnActions: "الإجراءات",

    // -- NEW KEYS FOR QUIZZES (Teacher Quizez) --
    quizezHeading: "الاختبارات",
    tableQuizezTitle: "الاختبارات حسب الاسم والدرجة",
    columnDuration: "المدة",
    columnStartDateQuiz: "تاريخ البداية",
    columnEndDateQuiz: "تاريخ النهاية",
    columnStartTime: "وقت البداية",
    columnEndTime: "وقت النهاية",
    columnQuizTarget: "هدف الاختبار",

    // -- NEW KEYS FOR STUDENTS (Teacher Students) --
    studentsHeading: "الطلاب",
    tableStudentsTitle: "الطلاب حسب الاسم",
    columnStudentName: "اسم الطالب",
    columnEmailAddress: "البريد الإلكتروني",
    columnPhone: "الهاتف",
    columnRegisterDate: "تاريخ التسجيل",

    homeworkShowAnswers: "عرض الإجابات",
    dialogFilesTitle: "ملفات الإجابات",
    dialogFilesDescription: "هنا يمكنك تنزيل أو عرض إجاباتك المرسلة.",
    loading: "جارٍ التحميل...",
    close: "إغلاق",
  },
};

export const AvailabilityData = {
  en: {
    loadingSchedule: "Loading Schedule",
    weeklySchedule: "Weekly Schedule",
    weeklyScheduleDesc: "Manage your weekly recurring and one-time events",
    addSchedule: "Add Schedule",
    noScheduleEntries: "No schedule entries found. Add one to get started.",
    addNewSchedule: "Add New Schedule",
    createScheduleDesc:
      "Create a new schedule entry. Click save when you're done.",
    dayLabel: "Day",
    startTimeLabel: "Start Time",
    endTimeLabel: "End Time",
    recurringLabel: "Recurring",
    yes: "Yes",
    no: "No",
    saving: "Saving...",
    saveSchedule: "Save Schedule",
    deleteSchedule: "Delete Schedule",
    deleteScheduleDesc:
      "Are you sure you want to delete this schedule entry? This action cannot be undone.",
    cancel: "Cancel",
    deleting: "Deleting...",
    delete: "Delete",
    editSchedule: "Edit Schedule",
    editScheduleDesc:
      "Make changes to the schedule entry. Click save when you're done.",
    saveChanges: "Save Changes",
    successScheduleCreated: "Schedule entry created successfully.",
    successScheduleUpdated: "Schedule entry updated successfully.",
    successScheduleDeleted: "Schedule entry deleted successfully.",
    error: "Error",
    success: "Success",
    actions: "Actions",
    timeLabel: "Time",
  },
  ar: {
    loadingSchedule: "تحميل الجدول",
    weeklySchedule: "الجدول الأسبوعي",
    weeklyScheduleDesc: "أدِر أحداثك المتكررة والمرّة الواحدة",
    addSchedule: "إضافة جدول",
    noScheduleEntries: "لم يتم العثور على جداول. قم بإضافة واحدة للبدء.",
    addNewSchedule: "إضافة جدول جديد",
    createScheduleDesc: "قم بإنشاء جدول جديد. انقر حفظ عند الانتهاء.",
    dayLabel: "اليوم",
    startTimeLabel: "وقت البدء",
    endTimeLabel: "وقت الانتهاء",
    recurringLabel: "متكرر",
    yes: "نعم",
    no: "لا",
    saving: "جارٍ الحفظ...",
    saveSchedule: "حفظ الجدول",
    deleteSchedule: "حذف الجدول",
    deleteScheduleDesc:
      "هل أنت متأكد أنك تريد حذف هذا الجدول؟ لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    deleting: "جارٍ الحذف...",
    delete: "حذف",
    editSchedule: "تعديل الجدول",
    editScheduleDesc: "قم بإجراء التغييرات على الجدول. انقر حفظ عند الانتهاء.",
    saveChanges: "حفظ التغييرات",
    successScheduleCreated: "تم إنشاء الجدول بنجاح.",
    successScheduleUpdated: "تم تحديث الجدول بنجاح.",
    successScheduleDeleted: "تم حذف الجدول بنجاح.",
    error: "خطأ",
    success: "نجاح",
    actions: "الإجراءات",
    timeLabel: "الوقت",
  },
};

export const PricesData = {
  en: {
    categoriesLabel: "Categories",
    selectCategoryPlaceholder: "Select category",
    subCategoriesLabel: "Sub Categories",
    selectSubCategoryPlaceholder: "Select sub categories",
    categoryRequiredError: "Category is required.",
    subCategoryRequiredError: "Sub category is required.",
    priceManagement: "Price Management",
    priceManagementDesc: "Manage your teaching price plans and features",
    addNewPrice: "Add New Price",
    searchPlaceholder: "Search prices...",
    noPricesFoundTitle: "No prices found",
    noPricesFoundDescSearch: "Try a different search term or",
    noPricesFoundDescDefault: "Get started by creating a new price plan.",
    active: "Active",
    inactive: "Inactive",
    individual: "Individual",
    group: (peopleCount) => `Group (${peopleCount} people)`,
    featuresLabel: "Features:",
    durationLabel: "Duration:",
    currencyLabel: "Currency:",
    LessonLabel: "Lessons:",
    // Dialogs and forms
    addPriceTitle: "Add New Price Plan",
    addPriceDesc: "Create a new price plan for your teaching services.",
    editPriceTitle: "Edit Price Plan",
    editPriceDesc: "Update the details of your price plan.",
    deletePriceTitle: "Delete Price Plan",
    deletePriceDesc:
      "Are you sure you want to delete this price plan? This action cannot be undone.",
    manageFeatures: "Manage Features",
    manageFeaturesDesc: (priceName) => `Add or edit features for ${priceName}`,
    // Form labels/placeholders
    nameLabel: "Name",
    namePlaceholder: "Premium Plan",
    priceLabel: "Price",
    discountLabel: "Discount (%)",
    groupNumLabel: "Group number",
    lessonNumLabel: "Lesson number",
    durationLabelForm: "Duration",
    typeLabel: "Type",
    selectCurrency: "Select a currency",
    selectType: "Select type",
    // Type options
    optionIndividual: "Individual",
    optionGroup: "Group",
    // Buttons
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    delete: "Delete",
    add: "Add",
    // Dropdown / actions
    actions: "Actions",
    edit: "Edit",
    deactivate: "Deactivate",
    activate: "Activate",
    // Toast titles and messages
    success: "Success",
    error: "Error",
    priceCreated: "Price plan created successfully!",
    priceUpdated: "Price plan updated successfully!",
    priceDeleted: "Price plan deleted successfully!",
    featureAdded: "Feature added successfully!",
    featureUpdated: "Feature updated successfully!",
    featureDeleted: "Feature deleted successfully!",
    priceDeactivated: "Price plan deactivated successfully!",
    priceActivated: "Price plan activated successfully!",
  },
  ar: {
    categoriesLabel: "الفئات",
    selectCategoryPlaceholder: "اختر فئة",
    subCategoriesLabel: "الفئات الفرعية",
    selectSubCategoryPlaceholder: "اختر فئة فرعية",
    categoryRequiredError: "يجب اختيار فئة.",
    subCategoryRequiredError: "يجب اختيار فئة فرعية.",
    priceManagement: "إدارة الأسعار",
    priceManagementDesc: "إدِر خطط أسعار التدريس والميزات الخاصة بك",
    addNewPrice: "أضف سعرًا جديدًا",
    searchPlaceholder: "ابحث عن الأسعار...",
    noPricesFoundTitle: "لم يتم العثور على أسعار",
    noPricesFoundDescSearch: "حاول عبارة بحث مختلفة أو",
    noPricesFoundDescDefault: "ابدأ بإنشاء خطة سعر جديدة.",
    active: "نشط",
    inactive: "غير نشط",
    individual: "فردي",
    // The group string receives the number of people dynamically.
    group: (peopleCount) => `مجموعة (${peopleCount} أشخاص)`,
    featuresLabel: "الميزات:",
    durationLabel: "المدة:",
    currencyLabel: "العملة:",
    LessonLabel: "الدورس:",
    addPriceTitle: "أضف خطة سعر جديدة",
    addPriceDesc: "قم بإنشاء خطة سعر جديدة لخدمات التدريس الخاصة بك.",
    editPriceTitle: "تحرير خطة السعر",
    editPriceDesc: "قم بتحديث تفاصيل خطة السعر الخاصة بك.",
    deletePriceTitle: "حذف خطة السعر",
    deletePriceDesc:
      "هل أنت متأكد أنك تريد حذف خطة السعر هذه؟ لا يمكن التراجع عن هذا الإجراء.",
    manageFeatures: "إدارة الميزات",
    manageFeaturesDesc: (priceName) => `أضف أو حرر الميزات لـ ${priceName}`,
    // Form labels/placeholders
    nameLabel: "الاسم",
    namePlaceholder: "الخطة المميزة",
    priceLabel: "السعر",
    discountLabel: "الخصم (%)",
    groupNumLabel: "عدد المجموعة",
    lessonNumLabel: "عدد الدروس",
    durationLabelForm: "المدة",
    typeLabel: "النوع",
    selectCurrency: "اختر العملة",
    selectType: "اختر النوع",
    // Options
    optionIndividual: "فردي",
    optionGroup: "مجموعة",
    // Buttons
    cancel: "إلغاء",
    create: "إنشاء",
    update: "تحديث",
    delete: "حذف",
    add: "أضف",
    // Dropdown / actions
    actions: "إجراءات",
    edit: "تحرير",
    deactivate: "تعطيل",
    activate: "تفعيل",
    // Toast
    success: "نجاح",
    error: "خطأ",
    priceCreated: "تم إنشاء خطة السعر بنجاح!",
    priceUpdated: "تم تحديث خطة السعر بنجاح!",
    priceDeleted: "تم حذف خطة السعر بنجاح!",
    featureAdded: "تمت إضافة الميزة بنجاح!",
    featureUpdated: "تم تحديث الميزة بنجاح!",
    featureDeleted: "تم حذف الميزة بنجاح!",
    priceDeactivated: "تم تعطيل خطة السعر بنجاح!",
    priceActivated: "تم تفعيل خطة السعر بنجاح!",
  },
};

export const GradebookData = {
  en: {
    gradebook: "Gradebook",
    quiz: "Quiz",
    assignment: "Assignment",
    score: "Score",
    quizName: "Quiz Name",
    assignmentName: "Assignment Name",
    quizDataTitle: "quiz by name",
    assignmentDataTitle: "assignment by name",
    searchStudent: "Search Student",
  },
  ar: {
    gradebook: "دفتر الدرجات",
    quiz: "اختبار",
    assignment: "واجب",
    score: "الدرجة",
    quizName: "اسم الاختبار",
    assignmentName: "اسم الواجب",
    quizDataTitle: "الاختبار حسب الاسم",
    assignmentDataTitle: "الواجب حسب الاسم",
    searchStudent: "البحث عن طالب",
  },
};

export const QuizData = {
  en: {
    availableQuizzesHeading: "Available Quizzes",
    notStarted: "Not Yet Started",
    expired: "Quiz Expired",
    showAnswers: "Show Answers",
    attempted: "Quiz Attempted",
    startQuiz: "Start Quiz",
    loading: "Loading Quiz...",
    quizTitle: "Quiz",
    previous: "Previous",
    next: "Next",
    submitQuiz: "Submit Quiz",
    submittedSuccessTitle: "Quiz Submitted Successfully!",
    submittedSuccessMessage:
      "You can now review your answers and the correct ones above.",
    attemptedBadge: "Attempted",
    gradesVisible: "Grades visible",
    gradesHidden: "Grades hidden",
    answersVisible: "Answers visible",
    answersHidden: "Answers hidden",
    lessonInformation: "Lesson Information",
    courseLabel: "Course:",
    startLabel: "Start:",
    endLabel: "End:",
    lessonLabel: "Lesson:",
  },
  ar: {
    availableQuizzesHeading: "الاختبارات المتاحة",
    notStarted: "لم يبدأ بعد",
    expired: "انتهى الاختبار",
    showAnswers: "عرض الإجابات",
    attempted: "اكتمل الاختبار",
    startQuiz: "بدء الاختبار",
    loading: "جاري تحميل الاختبار...",
    quizTitle: "الاختبار",
    previous: "السابق",
    next: "التالي",
    submitQuiz: "تقديم الاختبار",
    submittedSuccessTitle: "تم تقديم الاختبار بنجاح!",
    submittedSuccessMessage:
      "يمكنك الآن مراجعة إجاباتك والإجابات الصحيحة أعلاه.",
    attemptedBadge: "اكتمل الاختبار",
    gradesVisible: "الدرجات مرئية",
    gradesHidden: "الدرجات مخفية",
    answersVisible: "الإجابات مرئية",
    answersHidden: "الإجابات مخفية",
    lessonInformation: "معلومات الدرس",
    courseLabel: "المقرر:",
    startLabel: "بداية:",
    endLabel: "نهاية:",
    lessonLabel: "الدرس:",
  },
};

export const UserCoursesData = {
  en: {
    availableCourses: "Available Courses",
    enrollNow: "Enroll Now",
    noCoursesFound: "No courses found",
    checkBackLater: "Check back later for new courses",
    enrollIn: "Enroll in:",
    stepTitles: [
      "Select Level",
      "Select Teacher",
      "Select Date & Time",
      "Select Price",
      "Confirm",
    ],
    selectDateTime: "Select Date & Time",
    withTeacher: "With teacher:",
    availabilityError:
      "Failed to load teacher availability. Please try again later.",
    selectDate: "Select a date",
    selectTime: "Select an available time",
    noAvailableDates: "No available dates found.",
    noTimesSelected: "No times selected yet.",
    backToTeachers: "Back to Teachers",
    continueToPricing: "Continue to Pricing",
    selectTeacher: "Select a Teacher",
    teacherError: "Failed to load teachers. Please try again later.",
    noTeachers: "No teachers available for this course",
    tryAnotherCourse: "Please try another course",
    backToLevel: "Back to Level",
    experienced: "Experienced",
    selectLevel: "Select your level",
    noLevels: "No Levels available for this course",
    groupsCountLabel: "Groups:",
    confirmBooking: "Confirm Your Booking",
    enterPromoCode: "Enter promo code (optional)",
    submit: "Submit",
    processingPayment: "Processing Your Payment...",
    doNotClose: "Please do not close or refresh this page.",
    bookingConfirmed: "Booking Confirmed!",
    bookingReference: "Booking reference:",
    bookAnotherSession: "Book Another Session",
    paymentMethod: "Payment Method",
    myFatoorah: "My Fatoorah",
    paypal: "Paypal",
    bookingDetails: "Booking Details",
    courseLabel: "Course",
    teacherLabel: "Teacher",
    dateAndTimes: "Date & Times",
    levelLabel: "Level",
    packageLabel: "Package",
    priceLabel: "Price",
    termsMessage:
      "By confirming this booking, you agree to the terms and conditions of the service. Cancellations must be made at least 24 hours before the scheduled time.",
    backToPricing: "Back to Pricing",
    confirmAndPay: "Confirm and Pay",
    noCourseYet: "No courses yet",
    viewDetails: "View Details",
    startCourse: "Start Course",
    resumeCourse: "Resume Course",
    courseContent: "Course Content",
  },
  ar: {
    availableCourses: "الدورات المتاحة",
    enrollNow: "سجل الآن",
    noCoursesFound: "لم يتم العثور على دورات",
    checkBackLater: "تحقق لاحقًا للحصول على دورات جديدة",
    enrollIn: "التسجيل في:",
    stepTitles: [
      "اختر المستوى",
      "اختر المدرس",
      "اختر التاريخ والوقت",
      "اختر السعر",
      "تأكيد",
    ],
    selectDateTime: "اختر التاريخ والوقت",
    withTeacher: "مع المدرس:",
    availabilityError:
      "فشل في تحميل توافر المدرس. يرجى المحاولة مرة أخرى لاحقًا.",
    selectDate: "اختر التاريخ",
    selectTime: "اختر وقتًا متاحًا",
    noAvailableDates: "لا توجد تواريخ متاحة.",
    noTimesSelected: "لم يتم اختيار أوقات بعد.",
    backToTeachers: "العودة إلى المدرسين",
    continueToPricing: "متابعة إلى التسعير",
    selectTeacher: "اختر مدرسًا",
    teacherError: "فشل في تحميل المدرسين. يرجى المحاولة مرة أخرى لاحقًا.",
    noTeachers: "لا يوجد مدرسون متاحون لهذه الدورة",
    tryAnotherCourse: "يرجى تجربة دورة أخرى",
    backToLevel: "العودة إلى المستوى",
    experienced: "ذو خبرة",
    selectLevel: "اختر المستوى",
    noLevels: "لا توجد مستويات متاحة لهذه الدورة",
    groupsCountLabel: "المجموعات:",
    confirmBooking: "تأكيد الحجز",
    enterPromoCode: "أدخل رمز الترويج (اختياري)",
    submit: "إرسال",
    processingPayment: "جاري معالجة الدفع...",
    doNotClose: "يرجى عدم إغلاق أو تحديث هذه الصفحة.",
    bookingConfirmed: "تم تأكيد الحجز!",
    bookingReference: "مرجع الحجز:",
    bookAnotherSession: "حجز جلسة أخرى",
    paymentMethod: "طريقة الدفع",
    myFatoorah: "نفذ الفاتورة",
    paypal: "بايبال",
    bookingDetails: "تفاصيل الحجز",
    courseLabel: "الدورة",
    teacherLabel: "المدرب",
    dateAndTimes: "التاريخ والأوقات",
    levelLabel: "المستوى",
    packageLabel: "الباقة",
    priceLabel: "السعر",
    termsMessage:
      "بالموافقة على هذا الحجز، فإنك توافق على شروط وأحكام الخدمة. يجب إلغاء الحجز قبل 24 ساعة على الأقل من الوقت المحدد.",
    backToPricing: "العودة إلى التسعير",
    confirmAndPay: "تأكيد ودفع",
    noCourseYet: "لا توجد دورات بعد",
    viewDetails: "عرض التفاصيل",
    startCourse: "ابدأ الدورة",
    resumeCourse: "استئناف الدورة",
    courseContent: "محتوى الدورة",
  },
};
